export default {
  namespaced: true,
  state: {
    ui: {}
  },
  getters: {
    getUi (state) {
      return state.ui
    }
  },
  mutations: {
    USER_INTERFACE (state, obj) {
      let cloneState = { ...state.ui }
      for (let key in obj) {
        cloneState[key] = obj[key]
      }
      state.ui = cloneState
    },
    USER_INTERFACE_REMOVE (state, obj) {
      for (let key in obj) {
        delete state.ui[obj[key]]
      }
    }
  },
  actions: {
    setUi ({ commit }, obj) {
      commit("USER_INTERFACE", obj)
    },
    removeUi ({ commit }, obj) {
      commit("USER_INTERFACE_REMOVE", obj)
    }
  }
}
